import animateScrollTo, { IOptions, TCoords } from 'animated-scroll-to'

/* 
  Scroll To helper
*/
export type ScrollToParam = {
  el: IOptions['elementToScroll'] | null
  top?: boolean
  y?: number
  coord?: TCoords
}
export function scrollTo(param: ScrollToParam) {
  const { el, top, y, coord } = param

  if (!el) {
    return
  }

  if (top) {
    animateScrollTo(0, {
      elementToScroll: el
    })
  } else if (y) {
    animateScrollTo(y, {
      elementToScroll: el
    })
  } else if (coord) {
    animateScrollTo(coord, {
      elementToScroll: el
    })
  }
}
